import React, { Component, Fragment } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import injectSheet from 'react-jss'
import Modal from 'react-responsive-modal'
import ReactHtmlParser from 'html-react-parser'
import $ from 'jquery'
import Button from '../../../components/Button'
import Spinner from '../../../components/Spinner'
import Payment from '../../Payment'
import config from '../../../config/app'
import * as actionCreators from '../../../root/actions'
import { VISIT_URL } from '../../../api/endpoints'
import ConfirmationIcon from '../../../assets/icons/visit_confirmation.svg'
import CancelIcon from '../../../assets/icons/visit_cancel_confirmation.svg'
import RescheduleIcon from '../../../assets/icons/visit_reschedule.svg'
import LogoBlack from '../../../assets/icons/logo-black.svg'
import { desktopBreakpoint } from '../../../constants'
import style from './style'

export class SelectedAppointment extends Component {
  constructor(props) {
    super(props)
    this.state = {
      isShowWarning: false,
      isCancelWarning: false,
      hasCanceled: false,
      hasRescheduled: false,
      hasFee: false,
      isSubmitting: false
    }
    this.onCloseModal = this.onCloseModal.bind(this)
    this.getModalIcon = this.getModalIcon.bind(this)
    this.getModalSmallMsg = this.getModalSmallMsg.bind(this)
    this.getModalLargeMsg = this.getModalLargeMsg.bind(this)
    this.getModalBtnClass = this.getModalBtnClass.bind(this)
    this.getModalBtns = this.getModalBtns.bind(this)
    this.confirmAction = this.confirmAction.bind(this)
    this.changeAppointment = this.changeAppointment.bind(this)
    this.cancelAppointment = this.cancelAppointment.bind(this)
    this.rescheduleAppointment = this.rescheduleAppointment.bind(
      this
    )
  }

  componentDidMount() {
    const { schedule, app } = this.props.containers
    if (app.get('upcomingVisit') === null) this.props.setProgressBarPercent(50)

    if (schedule.get('isCancelFromUpcomingVisit')) {
      this.confirmAction(true)
    }
    if (window.innerWidth < desktopBreakpoint) {
      $('.main-content div').scrollTop(0)
    }
  }

  onCloseModal(dontNavAway) {
    const {
      getUserFromDBAndUpdateStore,
      changeRoute,
      cancelFromUpcomingVisit
    } = this.props

    getUserFromDBAndUpdateStore({
      onSuccess: () => {
        this.setState(
          {
            isShowWarning: false,
            hasCanceled: false,
            hasRescheduled: false
          },
          () => {
            if (!dontNavAway) changeRoute({ route: '/' })
            cancelFromUpcomingVisit(false)
          }
        )
      }
    })
  }

  getModalIcon(upcomingVisit) {
    if (this.state.isCancelWarning) {
      return <img src={CancelIcon} className="modalImg" alt="upcoming visit" />
    }

    if (this.state.hasRescheduled) {
      return (
        <img src={ConfirmationIcon} className="modalImg" alt="upcoming visit" />
      )
    }

    if (!this.state.isCancelWarning && upcomingVisit.status.lateFee) {
      return (
        <img src={RescheduleIcon} className="modalImg" alt="upcoming visit" />
      )
    }
    if (!this.state.isCancelWarning && !upcomingVisit.status.lateFee) {
      return (
        <img src={ConfirmationIcon} className="modalImg" alt="upcoming visit" />
      )
    }
  }

  getModalSmallMsg(upcomingVisit) {
    const { app } = this.props.containers
    if (this.state.hasCanceled) {
      return app.get('isMobile')
        ? 'Your appointment has <br/> been canceled.'
        : 'Your appointment has been canceled.'
    }
    if (this.state.hasRescheduled) return 'Great! Your Visit Is Confirmed For:'
    if (this.state.isCancelWarning && !upcomingVisit.status.lateFee) {
      return 'Are you sure you want to cancel your visit for'
    }

    if (!this.state.isCancelWarning && !upcomingVisit.status.lateFee) {
      return 'Great! Your Visit Is Confirmed For:'
    }

    if (upcomingVisit.status.lateFee) {
      return 'You are within 48 hours of your visit.'
    }
  }

  getModalLargeMsg(upcomingVisit) {
    if (
      (!upcomingVisit.status.lateFee &&
        upcomingVisit &&
        !this.state.hasCanceled) ||
      this.state.hasRescheduled
    ) {
      return upcomingVisit.longFormattedDate
    }

    if (
      upcomingVisit.status.lateFee &&
      this.state.isCancelWarning &&
      !this.state.hasCanceled
    ) {
      return 'Canceling will result in a $30.00 fee.'
    }
    if (
      upcomingVisit.status.lateFee &&
      !this.state.isCancelWarning &&
      !this.state.hasCanceled
    ) {
      return 'Rescheduling will result in a $30.00 fee.'
    }
  }

  getModalBtnClass() {
    const { app } = this.props.containers
    const upcomingVisit = app.get('upcomingVisit')

    if (this.state.hasRescheduled || this.state.hasCanceled) {
      return 'modal-button-area'
    }
    if (this.state.hasRescheduled) return 'modal-button-area'
    if (this.state.isCancelWarning || upcomingVisit.status.lateFee) {
      return 'modal-button-area two-buttons'
    } else return 'modal-button-area'
  }

  getModalBtns(upcomingVisit) {
    const { app } = this.props.containers
    const { changeRoute } = this.props

    return (
      <div className={`${this.getModalBtnClass()} twoButtons`}>
        {this.state.hasCanceled ||
          this.state.hasRescheduled ||
          (!this.state.isCancelWarning && !upcomingVisit.status.lateFee) ? (
          <Button fixed onClick={() => this.onCloseModal(false)} fullWidth>
            Close
          </Button>
        ) : (
          <Fragment>
            <Button
              scheme={app.get('isMobile') ? 'dark' : 'light'}
              fixed
              onClick={
                app.get('isMobile')
                  ? () => {
                    this.props.cancelFromUpcomingVisit(false)
                    changeRoute({ route: '/' })
                  }
                  : () => this.onCloseModal(true)
              }
            >
              Nevermind
            </Button>
            <Button
              fixedRight
              onClick={() =>
                this.state.isCancelWarning
                  ? this.cancelAppointment()
                  : this.rescheduleAppointment()
              }
            >
              {!upcomingVisit.status.lateFee ? 'Yes, Cancel' : 'Accept Fee'}
            </Button>
          </Fragment>
        )}
      </div>
    )
  }

  render() {
    const { confirmAction, props, state, changeAppointment } = this
    const { classes, changeRoute, selectTimeslot } = props
    const { schedule, app, payment } = props.containers
    const { isCancelWarning } = state

    const selectedTimeslot = schedule.get('selectedTimeslot')
      ? schedule.get('selectedTimeslot').longFormattedDate
      : schedule.get('selectedTimeslot')

    const costOfVisit = app.get('user').visit_cost
    const upcomingVisit = app.get('upcomingVisit')

    const bookBtnMsg = upcomingVisit !== null ? 'Reschedule' : 'Continue'
    const cancelBtnMsg = app.get('isMobile')
      ? 'Nevermind'
      : 'Cancel Appointment'

    const cancelBtnProps = {
      scheme: app.get('isMobile') ? 'dark' : 'light',
      onClick: app.get('isMobile')
        ? () => changeRoute({ route: '/' })
        : () => confirmAction(true),
      fullWidth: true,
      fixed: "true",
      disabled: upcomingVisit === null
    }

    const onBookClick = () => {
      if (upcomingVisit === null) changeRoute({ route: '/upcoming/terms' })
      else if (upcomingVisit.status.lateFee) {
        confirmAction(false)
      } else {
        confirmAction(false, changeAppointment)
      }
    }

    let isBookDisabled = true

    if (upcomingVisit === null) {
      isBookDisabled = !(payment.get('isPaymentValid') || costOfVisit === 0)
    } else {
      isBookDisabled = !schedule.get('selectedTimeslot')
    }

    const bookBtnProps = {
      scheme: 'dark',
      onClick: onBookClick,
      fullWidth: true,
      fixedRight: true,
      disabled: isBookDisabled,
      className: 'timeslot-btn'
    }

    const animationDuration = app.get('isMobile') ? 0 : 100

    return (
      <div className={classes.base}>
        {upcomingVisit && (
          <Modal
            classNames={{
              modal: 'feedback-modal modal-square',
              overlay: 'feedback-overlay',
              closeButton: 'modal-close-btn'
            }}
            open={this.state.isShowWarning}
            center
            showCloseIcon={false}
            animationDuration={animationDuration}
            onClose={() => this.onCloseModal(false)}
            closeOnOverlayClick={false}
            closeOnEsc
          >
            {app.get('isMobile') && (
              <div className="mobile-padding">
                <img src={LogoBlack} className="modal-logo" alt="header" />
              </div>
            )}
            {this.state.isSubmitting ? (
              <Spinner />
            ) : (
              <Fragment>
                <div className="modal-warning">
                  {this.getModalIcon(upcomingVisit)}
                  <div className={classes.messageContainer}>
                    {ReactHtmlParser(this.getModalSmallMsg(upcomingVisit))}
                    <br />
                    <br />
                    <div className={classes.upcomingVisit}>
                      {this.getModalLargeMsg(upcomingVisit)}
                    </div>
                  </div>
                </div>
                {this.getModalBtns(upcomingVisit)}
              </Fragment>
            )}
          </Modal>
        )}
        {upcomingVisit === null && (
          <div className="mobile-padding">
            {!app.get('isMobile') && (
              <hr className="gradient-divider noMarginPadding" />
            )}
            <h2>Payment</h2>
            <div className={classes.paymentDetails}>
              <div>
                Your visit will be scheduled for:
                <br />
                <br />
                <h1 className={classes.selectedTimeslot}>{selectedTimeslot}</h1>
                <br />
                {app.get('isMobile') && (
                  <Fragment>
                    <Button
                      scheme="light"
                      style={{ maxWidth: '190px', fontSize: '16px !important' }}
                      onClick={() => {
                        selectTimeslot(null)
                        if (app.get('upcomingVisit') === null) {
                          this.props.setProgressBarPercent(25)
                        }

                        this.props.resetMobileState()
                      }}
                    >
                      Change Date
                    </Button>
                    <br />
                    <br />
                    <br />
                    <br />
                    <br />
                  </Fragment>
                )}
                <div className={classes.costOfVisit}>
                  Cost of visit:
                  <br />
                  <h1 className={classes.price}>
                    ${costOfVisit}
                    {costOfVisit !== 0 && '*'}
                  </h1>
                </div>
                {costOfVisit !== 0 && (
                  <div className="footnote payment-note">
                    {config.payment.feeNotice}
                  </div>
                )}
              </div>
              {costOfVisit !== 0 && <Payment />}
            </div>
          </div>
        )}
        <Fragment>
          <div
            className={`${classes.buttonArea} ${upcomingVisit ? 'twoButtons' : ''
              } `}
          >
            {upcomingVisit !== null && (
              <Button {...cancelBtnProps}>{cancelBtnMsg}</Button>
            )}
            <Button {...bookBtnProps}>{bookBtnMsg}</Button>
          </div>
        </Fragment>
      </div>
    )
  }

  confirmAction(isCancelWarning, callback) {
    this.setState(
      {
        isShowWarning: true,
        isCancelWarning // can also be reschedule warning
      },
      callback
    )
  }

  changeAppointment() {
    if (this.state.isSubmitting) return
    this.setState({ isSubmitting: true })
    const { state, cancelAppointment, rescheduleAppointment } = this
    const { isCancelWarning } = state

    isCancelWarning ? cancelAppointment() : rescheduleAppointment()
  }

  cancelAppointment() {
    if (this.state.isSubmitting) return
    this.setState({ isSubmitting: true })
    const { apiRequest, containers, sortNav, selectTimeslot } = this.props
    const { app } = containers
    const { uuid } = app.get('upcomingVisit')

    const request = {
      url: `${VISIT_URL}/${uuid}`,
      method: 'delete'
    }

    const meta = {
      onError: error => {
        this.setState({ isSubmitting: false })
        console.log(error)
      },
      onSuccess: () => {
        this.setState({ hasCanceled: true, isSubmitting: false }, () => {
          sortNav()
          selectTimeslot(null)
        })
      }
    }

    apiRequest(request, meta)
  }

  rescheduleAppointment() {
    const {
      apiRequest,
      containers,
      getUserFromDBAndUpdateStore,
      sortNav,
      selectTimeslot
    } = this.props
    const { app, schedule } = containers
    const { uuid } = app.get('upcomingVisit')
    const date = schedule.get('selectedTimeslot').time

    const request = {
      url: `${VISIT_URL}/${uuid}`,
      method: 'put',
      data: { date }
    }

    const meta = {
      onError: error => {
        this.setState({ isSubmitting: false })
        console.log(error)
      },
      onSuccess: () => {
        this.setState({ hasRescheduled: true }, () => {
          getUserFromDBAndUpdateStore({
            onError: () => this.setState({ isSubmitting: false }),
            onSuccess: () => {
              sortNav()
              this.setState({ isSubmitting: false })
            }
          })
          selectTimeslot(null)
        })
      }
    }

    apiRequest(request, meta)
  }
}

const mapStateToProps = state => {
  const { containers, api } = state

  return {
    containers,
    api
  }
}

const mapDispatchToProps = dispatch => {
  return bindActionCreators(actionCreators, dispatch)
}

const styleAndTheme = theme => style

export default injectSheet(styleAndTheme)(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(SelectedAppointment)
)
